import {
    MDBBtn,
    MDBCheckbox,
    MDBDatatable,
    MDBIcon,
    MDBTabs,
    MDBTabsContent,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsPane
} from 'mdb-react-ui-kit';
import React, { useState } from 'react';
import Header from '../../components/header/Header';

function Devices() {

    const [basicActive, setBasicActive] = useState('tab1');

    const handleBasicClick = (value: string) => {
        if (value === basicActive) {
            return;
        }

        setBasicActive(value);
    };


    const actionData = {
        columns: [
            { label: 'User Name', field: 'UserName' },
            { label: 'Extension', field: 'Extension' },
            { label: 'PIN', field: 'PIN' },
            { label: 'Streams Softphone', field: 'StreamsSoftphone' },
            { label: 'IP Phone1', field: 'IPPhone1' },
            { label: 'IP Phone2', field: 'IPPhone2' },
        ],
        rows: [
            {
                UserName: 'mharish@panterranetworks.com ',
                Extension: '1306',
                PIN: 'PIN',
                StreamsSoftphone: (
                    <>
                        Streams_Android_4.0.170-s29d59d3ea9a58023
                        152.59.199.182:56133;transport=TLS
                        [07-Aug-2024 00:36:4]
                        Proxy:[10.20.8.214:5060]
                        <br />
                        <br />
                        Desktop_Chrome_12/127.0.0.0
                        202.65.142.206:42028
                        [07-Aug-2024 01:23:0]
                        Proxy:[10.20.8.67:8070]
                        Location: 38 North Almaden Blvd, Unit 1919, Kitchen, San Jose, CA, 95110 - 4087676981
                    </>
                ),
            },
            {
                UserName: 'mharish@panterranetworks.com ',
                Extension: '1306',
                PIN: 'PIN',
                StreamsSoftphone: (
                    <>
                        Streams_Android_4.0.170-s29d59d3ea9a58023
                        152.59.199.182:56133;transport=TLS
                        [07-Aug-2024 00:36:4]
                        Proxy:[10.20.8.214:5060]


                    </>
                ),
            },
            {
                UserName: 'mharish@panterranetworks.com ',
                Extension: '1306',
                PIN: 'PIN',
                StreamsSoftphone: (
                    <>
                        Streams_Android_4.0.170-s29d59d3ea9a58023
                        152.59.199.182:56133;transport=TLS
                        [07-Aug-2024 00:36:4]
                        Proxy:[10.20.8.214:5060]
                    </>
                ),
            },
            {
                UserName: 'mharish@panterranetworks.com ',
                Extension: '1306',
                PIN: 'PIN',
                phone: (
                    <>
                        Streams_Android_4.0.170-s29d59d3ea9a58023
                        152.59.199.182:56133;transport=TLS
                        [07-Aug-2024 00:36:4]
                        Proxy:[10.20.8.214:5060]
                    </>
                ),
            },
        ].map((row) => {
            return {
                ...row,
                IPPhone1: "NA",
                IPPhone2: "NA",
            };
        }),
    }
    const [checked, setChecked] = useState(false);

    const actionData2 = {
        columns: [
            { label: 'Login Time', field: 'loginTime' },
            { label: 'Device Type', field: 'deviceType' },
            { label: 'Device OS', field: 'deviceOS' },
            { label: 'Device App Version', field: 'deviceAppVersion' },
            { label: 'Device Status', field: 'deviceStatus' },
            { label: 'Force Logout', field: 'forceLogout', sort: false },
        ],
        rows: [
            {
                loginTime: '2024-08-07 10:00:00',
                deviceType: 'Mobile',
                deviceOS: 'Android',
                deviceAppVersion: '1.0.0',
                deviceStatus: 'Active',
                forceLogout: 'No',
            },
            {
                loginTime: '2024-08-07 11:00:00',
                deviceType: 'Desktop',
                deviceOS: 'Windows',
                deviceAppVersion: '1.2.0',
                deviceStatus: 'Inactive',
                forceLogout: 'Yes',
            },
            {
                loginTime: '2024-08-07 12:00:00',
                deviceType: 'Tablet',
                deviceOS: 'iOS',
                deviceAppVersion: '1.1.0',
                deviceStatus: 'Active',
                forceLogout: 'No',
            },
        ].map((row) => {
            return {
                ...row,
                forceLogout: (
                    <>
                        <MDBBtn className='logout-btn' onClick={() => console.log(`Force logout for ${row.deviceType} - ${row.deviceOS}`)}>
                            <MDBIcon icon='sign-out-alt' className='me-2' /> Force Logout
                        </MDBBtn>
                    </>
                ),
            };
        }),
    };
    const actionData3 = {
        columns: [
            { label: 'User Name', field: 'loginTime' },
            { label: 'Device Name', field: 'deviceType' },
            { label: 'Last Attempted Date', field: 'deviceOS' },
            { label: 'Browser Name', field: 'deviceAppVersion' }
        ],
        rows: [
            {
                loginTime: 'mharish@panterranetworks.com',
                deviceType: 'mharish@panterranetworks.com',
                deviceOS: '2024-08-07 10:00:00',
            },
        ].map((row) => {
            return {
                ...row,
                deviceAppVersion: "Chrome",
            };
        }),
    };

    return (
        <>
            <div className="mb-5">
                <Header />
            </div>
            <div style={{ marginTop: 55 }} className='p-4 customcard_height'>
                <MDBTabs className='mb-3'>
                    <MDBTabsItem>
                        <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                            Device Status
                        </MDBTabsLink>
                    </MDBTabsItem>
                    <MDBTabsItem>
                        <MDBTabsLink onClick={() => handleBasicClick('tab2')} active={basicActive === 'tab2'}>
                            Multiple Active Device Manager
                        </MDBTabsLink>
                    </MDBTabsItem>
                    <MDBTabsItem>
                        <MDBTabsLink onClick={() => handleBasicClick('tab3')} active={basicActive === 'tab3'}>
                            Pending Security Registrations
                        </MDBTabsLink>
                    </MDBTabsItem>
                </MDBTabs>

                <MDBTabsContent>
                    <MDBTabsPane open={basicActive === 'tab1'}>
                        <div className='card-header py-3 px-0'>
                            <h5>Devices</h5>
                        </div>
                        <div className="DeviceStatusDataTable">

                            <MDBDatatable
                                hover
                                selectable
                                multi
                                maxHeight='calc(100vh - 250px)'
                                pagination={false}
                                data={actionData} sortField="User Name"
                            />

                        </div>
                    </MDBTabsPane>
                    <MDBTabsPane open={basicActive === 'tab2'}>
                        <div className="d-flex align-items-start justify-content-between">
                            <div className='card-header py-3 px-0'>
                                <h5 className='m-0'>
                                    Login Settings
                                </h5>
                                <MDBCheckbox
                                    id='controlledCheckbox'
                                    label='Allow login to multiple devices'
                                    checked={checked}
                                    onChange={() => setChecked(!checked)}
                                />
                            </div>
                            <MDBBtn className='px-3'>Save</MDBBtn>
                        </div>
                        <div className="DeviceStatusDataTable">
                            <MDBDatatable
                                hover sortField="Login Time"
                                selectable
                                multi
                                maxHeight='calc(100vh - 250px)'
                                pagination={false}
                                data={actionData2} />
                        </div>
                    </MDBTabsPane>
                    <MDBTabsPane open={basicActive === 'tab3'}>
                        <div className="d-flex align-items-start justify-content-between">
                            <div className='card-header py-3 px-0'>
                                <h5 className='m-0'>
                                    Security Registrations
                                </h5>
                            </div>
                            <div className="d-flex align-items-start justify-content-between">
                                <MDBBtn className='px-3 me-2'>Register User(s) on Device(s)</MDBBtn>
                                <MDBBtn className='px-3'>Block User(s) on Device(s)</MDBBtn>
                            </div>
                        </div>
                        <div className="DeviceStatusDataTable">
                            <MDBDatatable
                                hover sortField="User Name"
                                selectable
                                multi
                                maxHeight='calc(100vh - 250px)'
                                pagination={false}
                                data={actionData3} />
                        </div>
                    </MDBTabsPane>
                </MDBTabsContent>


            </div>
        </>
    )
}

export default Devices
